export class GuestReport {
    status: string;
    fraudScore: number | null;
    userId: string;
    fullName: string;
    email: string;
    identity: string;
    dateOfBirth: string;
    transaction: string;
    joinDate: string;
    emailDeliverable: boolean;
    emailScore: number | null;
    listing: string;
    checkIn: string;
    checkOut: string;
    addressLine1: string;
    postcode: string;
    country: string;
    facebook: Facebook;
    linkedIn: LinkedIn;
    airbnb: Airbnb;
    whatsApp: WhatsApp;
    ipDetails: IpDetails;
    phoneDetails: PhoneDetails;
    createdFor: string;
    requestedOn: string;
    completedOn: string | null;
    appliedRules: AppliedRule[];
}

export class GuestReportLite {
    fraudScore: number | null;
    fullName: string;

    email: string;
    emailDeliverable: boolean;
    emailScore: number | null;

    facebook: Facebook;
    linkedIn: LinkedIn;
    airbnb: Airbnb;
    whatsApp: WhatsApp;

    phoneDetails: PhoneDetails;

    createdFor: string;
    requestedOn: string;

    appliedRules: AppliedRule[];
}

export class AppliedRule {
    id: string;
    name: string;
    operation: string;
    score: number;
}

export class IpDetails {
    ip: string;
    country: string;
    state: string;
    city: string;
    isp: string;
    latitude: number | null;
    longitude: number | null;
    type: string;
    openPorts: number | null;
    score: number | null;
}

export class Airbnb {
    registered: boolean;
    createdAt: string | null;
    firstName: string;
    identityVerified: string;
    location: string;
    reviewCount: string;
    trips: number | null;
}

export class Facebook {
    registered: boolean;
}

export class WhatsApp {
    registered: boolean;
    lastSeen: string;
}

export class LinkedIn {
    registered: boolean;
}

export class PhoneDetails {
    number: number | null;
    country: string;
    valid: boolean;
    type: string;
    disposable: boolean;
    carrier: string;
    score: number | null;
}